/* eslint-disable import/prefer-default-export -- Named export is re-exported by utils index */
import { CHARACTER_MODERATION_STATUS, ICharacter } from "@next-platform/client-common-core";

import { GroupMembersChatBot } from "@/components/MembersGroupChat";
import { IDraftGroupCharacter } from "@/types";

const isAwaitingFix = (draft: IDraftGroupCharacter): boolean => {
  if (draft.moderationReport?.moderation_status === CHARACTER_MODERATION_STATUS.FIX_REQUIRED) {
    return true;
  }

  return !!draft.sub_characters?.some((member: GroupMembersChatBot) => member.moderation_status === CHARACTER_MODERATION_STATUS.FIX_REQUIRED);
};

/**
 * Returns the ids of group chat drafts that the server has since moved off `FIX_REQUIRED`, so the
 * caller can retire them through `useGroupChatDrafts.deleteDraft`.
 *
 * This deliberately returns ids instead of writing to storage. Group chat drafts live under their
 * own key, while the character helper `syncDraftCharacters` writes to the character draft key, so
 * reusing that helper here overwrote the user's character drafts with group chat records.
 *
 * `apiData` is a single paginated page of the user's group chats, so a draft with no matching group
 * chat is not necessarily orphaned. Only a status that actually differs retires a draft.
 */
export function getResolvedGroupChatDraftIds(drafts: IDraftGroupCharacter[], apiData: ICharacter[]): string[] {
  return drafts.reduce<string[]>((resolvedIds, draft: IDraftGroupCharacter) => {
    const draftId = draft.id || draft.character_id;

    if (!draftId || !isAwaitingFix(draft)) {
      return resolvedIds;
    }

    const groupChat = apiData.find((chatbot: ICharacter) => chatbot?.id === draft.id);

    if (groupChat && groupChat.moderationReport?.moderation_status !== draft.moderationReport?.moderation_status) {
      resolvedIds.push(draftId);
    }

    return resolvedIds;
  }, []);
}
